import { createSlice } from '@reduxjs/toolkit';
const initialState = {};
const typingIndicatorStyleSlice = createSlice({
  name: 'typingIndicatorStyle',
  initialState,
  reducers: {
    setTypingIndicatorStyle: (state, action) => {
      const {
        threadId,
        senderId,
        style
      } = action.payload;
      if (!state[threadId]) {
        state[threadId] = {};
      }
      state[threadId][senderId] = {
        style
      };
    }
  }
});
export const {
  setTypingIndicatorStyle
} = typingIndicatorStyleSlice.actions;
export default typingIndicatorStyleSlice.reducer;